// src/pages/Appli/AppliAdmin/VisitorCenter/hooks/useVisitorAnalytics.js

import {
  useCallback,
  useEffect,
  useState,
} from "react";

import {
  getVisitorAnalytics,
} from "./../../../../../services/visitorAnalyticsServices";

function formatInputDate(date) {
  const year =
    date.getFullYear();

  const month = String(
    date.getMonth() + 1,
  ).padStart(2, "0");

  const day = String(
    date.getDate(),
  ).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function getDefaultCustomPeriod() {
  const dateTo = new Date();
  const dateFrom = new Date();

  dateFrom.setDate(
    dateFrom.getDate() - 29,
  );

  return {
    date_from:
      formatInputDate(dateFrom),

    date_to:
      formatInputDate(dateTo),
  };
}

const INITIAL_FILTERS = {
  range: "30d",
  date_from: "",
  date_to: "",
  exclude_bots: "true",
};

export default function useVisitorAnalytics({
  enabled = false,
} = {}) {
  const [data, setData] =
    useState(null);

  const [filters, setFilters] =
    useState(INITIAL_FILTERS);

  const [loading, setLoading] =
    useState(false);

  const [
    errorMessage,
    setErrorMessage,
  ] = useState("");

  const updateFilter =
    useCallback((name, value) => {
      setFilters((current) => ({
        ...current,
        [name]: value,
      }));
    }, []);

  const setRange =
    useCallback((range) => {
      setFilters((current) => {
        if (range !== "custom") {
          return {
            ...current,
            range,
          };
        }

        const defaultPeriod =
          getDefaultCustomPeriod();

        return {
          ...current,

          range: "custom",

          date_from:
            current.date_from ||
            defaultPeriod.date_from,

          date_to:
            current.date_to ||
            defaultPeriod.date_to,
        };
      });
    }, []);

  const refresh = useCallback(
    async ({
      silent = false,
    } = {}) => {
      if (!enabled) {
        return null;
      }

      if (
        filters.range ===
          "custom" &&
        (!filters.date_from ||
          !filters.date_to)
      ) {
        setErrorMessage(
          "Sélectionnez une date de début et une date de fin.",
        );

        return null;
      }

      try {
        if (!silent) {
          setLoading(true);
        }

        setErrorMessage("");

        const params = {
          exclude_bots:
            filters.exclude_bots,
        };

        if (
          filters.range ===
          "custom"
        ) {
          params.date_from =
            filters.date_from;

          params.date_to =
            filters.date_to;
        } else {
          params.range =
            filters.range;
        }

        const response =
          await getVisitorAnalytics(
            params,
          );

        const nextData =
          response?.data || null;

        setData(nextData);

        return nextData;
      } catch (error) {
        const message =
          error?.response?.data
            ?.error ||
          error?.response?.data
            ?.message ||
          "Impossible de récupérer les statistiques visiteurs.";

        setErrorMessage(message);

        return null;
      } finally {
        if (!silent) {
          setLoading(false);
        }
      }
    },
    [
      enabled,
      filters.date_from,
      filters.date_to,
      filters.exclude_bots,
      filters.range,
    ],
  );

  useEffect(() => {
    if (!enabled) {
      return;
    }

    if (
      filters.range ===
        "custom" &&
      (!filters.date_from ||
        !filters.date_to)
    ) {
      return;
    }

    refresh();
  }, [
    enabled,
    refresh,
    filters.range,
    filters.date_from,
    filters.date_to,
    filters.exclude_bots,
  ]);

  return {
    data,
    filters,

    loading,
    errorMessage,

    setRange,
    updateFilter,
    refresh,
  };
}